import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { store, persistor } from "./store/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import "./index.css";
import App from "./App";
import { StyledEngineProvider } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import { setCount } from "./store/slices/countSlice";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import ErrorBoundary from "./globals/components/ErrorBoundary";
import { purgePersistedJwtFields } from "./globals/utils/authSession";

purgePersistedJwtFields();

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || "",
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
  tracesSampleRate: 0.1,
});

const theme = createTheme({
  typography: {
    fontFamily: "'Roboto', sans-serif",
    allVariants: {
      fontFamily: "'Roboto', sans-serif",
    },
  },
});

// ✅ BroadcastChannel for syncing Redux state across tabs (with fallback)
try {
  const channel = new BroadcastChannel("redux_sync");
  channel.onmessage = (event) => {
    if (event.data && event.data.type === "UPDATE_COUNT") {
      store.dispatch(setCount(event.data.payload));
    }
  };
} catch (e) {
  // BroadcastChannel not available (incognito mode, iframe restrictions, etc.)
}

// Fallback: localStorage event listener for cross-tab sync
window.addEventListener("storage", (event) => {
  if (event.key === "count") {
    store.dispatch(setCount(Number(event.newValue)));
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <PersistGate loading={null} persistor={persistor}>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </PersistGate>
          </ThemeProvider>
        </StyledEngineProvider>
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>
);
